<template>
  <div class="xs bg6">
    <div class="flex xs-fs2 fs3 c5 pt6 pr6 pl6 fw7 xs-middle">{{ $t("number_of_drawings") }}: {{ computedDrawings.length }}</div>
    <div class="drawing-container" v-if="computedDrawings && computedDrawings.length > 0">
      <div class="drawing list pl6 pr6 pt7">
        <div
          v-for="(item, index) in computedDrawings"
          :key="index"
          class="item r1 p2 mb3"
          :class="[isActive(item) ? 'bg2 c5' : 'bg4 c1']"
          @click="selectObject(item)"
        > 
         <!-- Remove -->
          <div class="remove" @click="removeDrawing(item)">
            <crm-icon name="cross" size="xsmall" />
          </div>
          <div>
            <!-- Liquid Source -->
            <div class="pb2 sm-pt2 mg-mt0">
              <p class="fs3 mb1 fw7" :class="[isActive(item) ? 'c5' : 'c6']" >{{`${$t("text_or_liquid")}:`}}</p>
              <p v-if="item.liquidSource === ''" class="fs3 fw4 pl1">{{$t("errors.no_data")}}</p>
              <textarea 
                readonly 
                class="list-detail fs3 fw4 lh125" :class="[isActive(item) ? 'c5' : 'c1']" 
                :value="item.liquidSource"
              />
            </div>
            
            <div class="flex xs-12 xs-right">
              <!-- Duplicate -->
              <j-button 
                type="secondary" 
                size="xsmall" 
                @click="duplicateDrawing(item)"
                class="fs3 mr1"
              >{{ $t("duplicate") }}</j-button>
              <!-- Edit -->
              <j-button 
                type="secondary" 
                size="xsmall" 
                @click="editLiquid(item)"
                class="fs3"
              >{{ $t("edit") }}</j-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"

export default {
	components: {
    CrmIcon,
    JButton
	},
	props: {
		drawings: {
			type: Array
		},
		activeObject: {
			type: Object
		},
		selectObject: {
			type: Function
    },
    page: {
      type: Number | String
    }
	},
	methods: {
		getEdits(item) {
			return [
				{
					label: "Edit",
					fn: this.editLiquid
				}
			]
		},

		editLiquid(item) {
			this.$emit("editLiquid", item)
		},

		isActive(item) {
			return this.activeObject?.id === item.id
		},

		removeDrawing(item) {
			this.$emit("removeDrawing", item)
    },
    
    duplicateDrawing(item) {
      this.$emit("duplicateDrawing", item)
    }
  },
  
  computed: {
    computedDrawings() {
      return this.drawings.filter(drawing => drawing.page === this.page)
        .sort((a,b) => a.point2.y - b.point2.y)
    }
  }
}
</script>

<style scoped>
@import "../../../../assets/css/tokens.css";

.item {
	position: relative;
}
.remove {
	position: absolute;
	top: 4px;
	right: 4px;
}

.showOnHover {
	display: flex;
	height: 10px;
}

.item:hover,
.edit:hover,
.remove:hover {
	cursor: pointer;
}

.list.drawing {
	height: 826px;
}

.drawing-container {
	overflow-y: scroll;
}

.list-detail {
	display: block;
  width: 100%;
  height: 100px;
	padding: var(--spacing1);
	background-color: rgba(0,0,0,0);
	border: 0px;
	font-family: var(--fontFamily1);
  outline: 0;
  resize: none;
  cursor: pointer;
	-webkit-appearance: none;
	-moz-appearance: none;
}
</style>